module.exports = __webpack_public_path__ + "static/media/XEMUSD.27625bc5.svg";